import { Group, Text, TextProps, Tooltip } from "@mantine/core"
import { LabeledValue } from "../../../../-components/default-list/labeled-value"
import { getFormattedDate } from "../../../../utils/get-formatted-date"
import { getDurationFormatted } from "./getDurationFormatted"
import {
  WorkingTimeBookingPairDto,
  WorkingTimeBookingDto,
} from "@/orval/gen/model"
import { getWorkingTimeImportStatusColor } from "../working-time-bookings/getWorkingTimeImportStatusColor"
import { WorkingTimeImportStatusBadge } from "../working-time-bookings/WorkingTimeImportStatusBadge"

function Booking({ booking }: { booking: WorkingTimeBookingDto }) {
  const getBookingProps: (booking: WorkingTimeBookingDto) => TextProps = (
    booking
  ) => ({
    bg: getWorkingTimeImportStatusColor(booking.status),
    px: "xs",
    py: 0,
    bdrs: "sm",
  })
  const Label = React.memo(() => (
    <>
      <Text>
        {booking.type.name} ({booking.source})
      </Text>
      <Text>{getFormattedDate(booking.timeStamp, "L LT")}</Text>
      {booking.note && <Text>{booking.note}</Text>}
      {booking.status && (
        <WorkingTimeImportStatusBadge status={booking.status} />
      )}
    </>
  ))
  return (
    <Tooltip label={<Label />}>
      <Text span {...getBookingProps(booking)}>
        {getFormattedDate(booking.timeStamp, "LT")}
      </Text>
    </Tooltip>
  )
}

export function WorkingTimeBookingPairListItem({
  bookingPair,
  onClick,
  selected,
}: {
  bookingPair: WorkingTimeBookingPairDto
  onClick?: (item: WorkingTimeBookingPairDto) => void
  selected?: boolean
}) {
  const { checkIn, checkOut } = bookingPair

  const type = checkIn?.type || checkOut?.type
  const isTimeAccountBookingType = type?.bookingCategory === "TimeAccount"

  const duration = getDurationFormatted(checkIn?.timeStamp, checkOut?.timeStamp)

  return (
    <>
      <LabeledValue
        {...(selected
          ? {
              style: {
                border: "2px solid var(--mantine-color-gray-5)",
                padding: 1,
              },
            }
          : {})}
        onClick={() => onClick?.(bookingPair)}
        label={type?.shiftTypeName}
        {...(onClick ? { style: { cursor: "pointer" } } : {})}
        value={
          <Group justify="space-between" flex={1}>
            <Text>
              {!isTimeAccountBookingType ? (
                <>
                  {checkIn && <Booking booking={checkIn} />}
                  {checkOut && (
                    <Text span>
                      {" "}
                      - <Booking booking={checkOut} />
                    </Text>
                  )}
                </>
              ) : (
                type?.shiftTypeName
              )}
            </Text>
            <Group>
              <Text>{duration}</Text>
            </Group>
          </Group>
        }
        description={`${checkIn?.note || ""}${checkOut?.note ? ` / ${checkOut.note}` : ""}`}
      />
    </>
  )
}
